import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createdrivefile">
                1.&nbsp;<span className="material-symbols-outlined">add_to_drive</span>&nbsp;{translate('createdrivefile')}
            </Typography>
            <p><strong>{translate('createdrivefile')}</strong> là một hành tải 1 tệp lên Google Drive.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$newDriveID_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối Google Drive được sử dụng để xác định tài khoản Google Drive (xem <Box component={Link} to="/control-center/documentation/connections/drive">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tệp muốn tải lên.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$newDriveID_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gdrive-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/combine.pdf</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>1MaW_N9XOSkvq7F-y7J0JE5dhafAqjHfu</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getdrivefile">
                2.&nbsp;<span className="material-symbols-outlined">downloading</span>&nbsp;{translate('getdrivefile')}
            </Typography>
            <p><strong>{translate('getdrivefile')}</strong> là một hành tải xuống 1 tệp từ Google Drive.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$driveFile_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối Google Drive được sử dụng để xác định tài khoản Google Drive (xem <Box component={Link} to="/control-center/documentation/connections/drive">tại đây</Box> để biết cách tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('fileid')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ID hoặc URL của tệp muốn tải xuống.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$driveFile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gdrive-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('fileid')}</span>
                            <div>1MaW_N9XOSkvq7F-y7J0JE5dhafAqjHfu</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/combine.pdf</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);